<div
    class="agpr-text-input-chips"
    [class.agpr-text-input-chips--hasChips]="alwaysShowChips || (value && value.length > 0)"
    [ngClass]="{'agpr-text-input-chips--social' : style === agprComponentStyle.social}"
>
    <agpr-text-input
        #textInput
        [id]="id"
        class="agpr-text-input-chips-textInput"
        [disabled]="disabled"
        [readonly]="readonly"
        [placeholder]="placeholder | localize"
        [bottomMargin]="false"
        [(ngModel)]="newChip"
        (focus)="tryWrite()"
        (blur)="onBlur($event)"
        (keydown)="onKeyDown($event)"
        [label]="header"
        [tooltip]="tooltip"
        [icon]="icon"
        [iconTooltip]="iconTooltip"
        [iconColor]="iconColor"
        [ariaLabel]="ariaLabel"
        [ariaLabelledBy]="ariaLabelledBy"
        [ariaInvalid]="ariaInvalid || chipValidationErrors.length > 0"
        [ariaDescribedBy]="(value && value.length > 0 ? id + '_chips ' : '') + (chipValidationErrors.length ? id + 'chipValidationErrors ' : '') + ariaDescribedBy"
        [required]="required"
    ></agpr-text-input>
    <agpr-chips
        *ngIf="alwaysShowChips || (value && value.length > 0)"
        [id]="id + '_chips'"
        class="agpr-text-input-chips-chips"
        [style]="style"
        [useLink]="useLink"
        [(ngModel)]="value"
        [disabled]="disabled"
        [clearAllChipsTooltip]="clearAllChipsTooltip"
        [placeholder]="chipPlaceholder"
        (ngModelChange)="onModelChange(value)"
        [ariaLabelledBy]="id + '_label'"
        (allChipsRemoved)="focusInput()"
    ></agpr-chips>
</div>
@if (chipValidationErrors.length) {
    <ul [id]="`${id}_chipValidationErrors`">
        @for (error of chipValidationErrors; track error; let i = $index) {
            <li>
                <agpr-form-message
                    [id]="`${id}_chipValidationErrors_${i}`"
                    [marginBottom]="0"
                >
                    {{ error | localize }}
                </agpr-form-message>
            </li>
        }
    </ul>
}
